import React, { useState } from "react";
import { Facility, FacilityType, rng, stringUtil } from "../../../amorg-common";
import { Card } from "../../../designSystem/Card";
import { createFacility } from '../../../api/locationClientApi';
import { FacilityEditor } from "./FacilityEditor";
import { LoadingPageOverlay } from "../../../designSystem/LoadingPageOverlay";
import { Modal } from "../../../designSystem/Modal";
import { getFacilityTypeIcon } from '../../../utils/facilityHelper';
import { ListItem } from "../../../designSystem/List/ListItem";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Button } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";

type FacilityListProps = {
    locationId: string,
    facilities:Facility[],
    allFacilityTypes:FacilityType[],
    onUpdated:()=>Promise<void>
}
export default function FacilityList(props:FacilityListProps):JSX.Element
{
    const [loading, setLoading] = useState(false);
    const [inEditId, setInEditId] = useState('');

    async function handleFacilityUpdated()
    {
        await props.onUpdated();
    }

    async function handleFacilityDeleted()
    {
        await props.onUpdated();
        setInEditId('');
    }

    async function handleFacilityClose(){
        setInEditId('');
    }

    async function handleCreateFacility(){
        
        setLoading(true);

        const nextId = rng.getRandomId();
        const nameBase = 'Ny facilitet';
        const nextName = stringUtil.generateNextSequenceValue(nameBase, props.facilities.map(fa => fa.name));
        const result = await createFacility(nextId, nextName, "", "", "other", props.locationId);

        if(result.isSuccess){
            await props.onUpdated();
            setInEditId(nextId);
        }
        setLoading(false);
    }

    async function handleClickFacility(facilityId){
        setInEditId(facilityId)
    } 
    
    // May be undefined
    const inEditFacility = inEditId ? props.facilities.find(x => x.id === inEditId) : undefined;

    return (
        <>
        <LoadingPageOverlay loading={loading} />
        {props.facilities &&
            <>
            
            
                {props.facilities.length === 0 &&
                    <div style={{ padding: 16 }}>
                        Ingen faciliteter oprettet
                    </div>
                }

                <Flex flexDirection="column" gap={2}>
                    {props.facilities.map(facility => 
                        <Card key={facility.id} variant="outlined" padding="8px">
                            <ListItem
                                leadingIcon={getFacilityTypeIcon(facility.facilityType.id)}
                                primaryText={facility.name}
                                secondary={{
                                    text: facility.facilityType.name
                                }}
                                button={{
                                    icon:'interface_actions_edit',
                                    variant: "text",
                                    size: "32px",
                                    onClick: () => handleClickFacility(facility.id)
                                }}
                            />
                        </Card>
                    )}
                </Flex>

                <ButtonRow marginTop={8}>
                    <Button text="Tilføj facilitet" icon="actions_plus" variant="text" onClick={handleCreateFacility} />
                </ButtonRow>

                <Modal 
                    title={"Rediger facilitet"}
                    content={
                        <FacilityEditor
                            facility={inEditFacility as Facility}
                            allFacilityTypes={props.allFacilityTypes}
                            onFacilityUpdated={handleFacilityUpdated}
                            onFacilityDeleted={handleFacilityDeleted}
                            onFacilityClose={handleFacilityClose}
                        />
                    }
                    showModal={inEditId!=='' && inEditFacility!==undefined}
                    onCancel={handleFacilityClose}
                />
            
            </>
            }
        </>
    );
 }